/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Tile_AccruedInputs */



/**
* | output |
* | --- |
* | "Accrued" |
*
* @param {Partner_Admin_Commission_Tile_AccruedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_tile_accrued = /** @type {((inputs?: Partner_Admin_Commission_Tile_AccruedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Tile_AccruedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aufgelaufen")
	return /** @type {LocalizedString} */ ("Accrued")
});